const PlanTypes = [
  { text: "ESOP", value: "ESOP" },
  { text: "Trust", value: "Trust" },
  { text: "Stock Appreciation Rights", value: "SAR" },
];
export default PlanTypes;
